export default __webpack_public_path__ + "static/char-v-03-c93dbe0dc130199d17366c1fbfc52e3e.png";